export interface BaseAhu {
  AhuId: string
  Description: string
  Information: string
  UnitCode: string
  PreviewImage: string
  Area: DisplayValue
  Supply: DisplayValue
  Extract: DisplayValue
  SFP: DisplayValue
  TemperatureEfficiencyEN13141: DisplayValue
  TemperatureEfficiencyEN308: DisplayValue
  State: AhuState
}
export type PropertyValue = string | number | boolean | null | undefined

export interface Item {
  TextId: string
  Name: string
  Value: PropertyValue
}

export interface Metadata {
  Key: string
  Value: PropertyValue
  ValueType: unknown
}

export interface ValueType {
  Key: string
  IsNumeric: boolean
  IsText: boolean
  IsBoolean: boolean
}

export interface BaseProperty {
  Key: string
  Value: PropertyValue
  TextId: string
  TitleSuffix?: string
  MeasurementUnitTextId: string
  IsSubProperty?: boolean
  ValueType: ValueType
  Metadata: Metadata[]
  Decimals?: number
}

export interface Property extends BaseProperty {
  MeasurementUnit: string
  IsVisible: boolean
  IsEnabled: boolean
  IsRequired: boolean
  MinValue?: number
  MaxValue?: number
  Items: Item[]
}

export interface Group {
  TextId: string
  Key: string
  IsVisible: boolean
  Properties: Property[]
  Metadata: Metadata[]
}

export interface Entity {
  Id: string
  TextId: string
  Groups: Group[]
}

export interface DisplayValue {
  Value?: number
  Display: string
  MeasurementUnit: string
}

export enum AhuState {
  NotCalculated = 0,
  Calculated,
  CalculatedWithWarnings,
  CalculatedWithErrors,
}
